
import { Component, Mixins } from "vue-property-decorator";
import { IConditionalExpressionBehavior } from "../../../../../../documaker/domain/format/objects";
import { IConditionalExpressionBehaviorPropertyEditable, instanceOfIConditionalExpressionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ConditionalExpressionBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IConditionalExpressionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IConditionalExpressionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isConditionalExpressionBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIConditionalExpressionBehaviorPropertyEditable(s) && s.conditionalExpressionBehavior().isEditable(), false);
  }

  get conditionalExpressionBehavior(): IConditionalExpressionBehavior {
    return this.readPropertyOrDefault(s => s.conditionalExpressionBehavior().getValue(), { contents: [] });
  }

  set conditionalExpressionBehavior(value: IConditionalExpressionBehavior) {
    this.writePropertyWhenValid(s => s.conditionalExpressionBehavior().setValue(value));
  }
}
